import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { eventsV2 } from 'apiv2'
import { notification } from 'antd'
import { Layout } from 'components'
import ScannerDetails from './ScannerDetails'
import { useQuery } from 'utils'

import EventsList from './EventsList'
import './index.styl'

const msgError = error => {
  const message = error?.response?.data?.message
  notification.warning({ message })
}

const transformData = (arr = []) => arr.map(i => i.eventID)
const transformTicketData = (arr = []) => arr.map(t => ({ ...t, name: t?.fullName }))
const paginationDefault = {
  current: 1,
  total: 0,
  limit: 5,
}
const Scanner = () => {
  const { eventID } = useParams()
  const { push } = useHistory()
  const [pagination, setPagination] = useState(paginationDefault)
  const [loading, setLoading] = useState(true)
  const [events, setEvents] = useState([])
  const [event, setEvent] = useState(null)
  const [tickets, setTickets] = useState([])
  const query = useQuery()

  useEffect(() => {
    window.dataLayer.push({ event: 'Scanner' })
    updateEvents(+query.get('page') || 1)
    return () => {
      setEvents([])
      setEvent(null)
    }
  }, [eventID])

  const updateEvents = (current = 1) => {
    const params = {
      limit: paginationDefault.limit,
      skip: (current * pagination.limit) - pagination.limit,
      search: '',
    }
    if (eventID) {
      eventsV2
        .getScannerTickets(eventID, params)
        .then(({ data = {} }) => {
          setEvent(data?.eventDetails)
          setPagination({ ...pagination, total: data.count, current: pagination.current })
          setTickets(transformTicketData(data?.scannedTickets))
        })
        .catch(error => {
          // a 401 is handled globally (silent sign-out to /auth/sign-in): no toast, no /scanner redirect on top of it
          if (error?.response?.status === 401) return
          push('/scanner')
          msgError(error)
        })
        .finally(() => setLoading(false))
    } else {
      eventsV2
        .getMyScannerEvents()
        .then(({ data: { data = {} } }) => setEvents(transformData(data)))
        // a 401 is handled globally (silent sign-out to /auth/sign-in): no empty toast on top of it
        .catch(error => error?.response?.status === 401 ? undefined : msgError(error))
        .finally(() => setLoading(false))
    }
  }

  const onChange = (current, pageSize) => {
    const skip = (current * pageSize) - paginationDefault.limit
    const params = {
      limit: paginationDefault.limit,
      search: '',
      skip,
    }
    setLoading(true)
    eventsV2
      .getScannerTickets(eventID, params)
      .then(response => {
        setPagination({ ...pagination, total: response.data.count, current })
      })
      .catch(err => err)
      .finally(() => setLoading(false))
  }

  return (
    <Layout className='scannerContainer'>
      {eventID
        ? <ScannerDetails onChange={onChange} pagination={pagination} loading={loading} event={event} tickets={tickets} />
        : <EventsList events={events} loading={loading} />}
    </Layout>
  )
}

export default Scanner
